import React, { useState } from "react";
import Footer from "../components/Footer"; // Adjust the path as needed
import "../styles/Careers.css"; // Make sure to import the CSS file

const Careers = () => {
  const [fileName, setFileName] = useState("No file chosen");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file ? file.name : "No file chosen");
  };
  return (
    <div className="careers-container">
      {/* Header Section */}
      <header className="careers-header">
        <h1>Careers at Westfield Transport Ltd.</h1>
        <p>Join our team and drive your career forward with us!</p>
      </header>

      <section className="careers-position">
        <h2>Truck Driver Position</h2>

        <h3>Position Summary</h3>
        <p>
          Responsible for transporting a variety of cargo on a trailer while ensuring compliance with safety regulations and securing loads properly.
          Your role includes conducting pre-trip and post-trip inspections, managing delivery schedules, and operating the vehicle safely on various routes.
        </p>

        <h3>What You Will Do</h3>
        <ul>
          <li>Making deliveries in a safe and timely manner</li>
          <li>Constant communication with the customer</li>
          <li>
            Conduct thorough pre-trip and post-trip inspections of the vehicle, including checking tires, brakes, lights, and cargo securement, and report any issues to the maintenance department for timely repairs.
          </li>
        </ul>

        <h3>What You’ll Bring</h3>
        <ul>
          <li>1 year of verifiable AZ driving experience</li>
          <li>Valid AZ license/Class 1 license</li>
          <li>U.S. Visa required; FAST Card holder preferred</li>
          <li>LTL experience is an asset</li>
          <li>Less than High School, but has basic reading, communication, and arithmetic skills to follow direction</li>
        </ul>

        <h3>Why People Love Working For Us</h3>
        <ul>
          <li>Cohesive team and a positive, hard-working atmosphere</li>
          <li>Meaningful opportunities for career growth</li>
          <li>We give back to the communities by volunteering and donating to local charities</li>
          <li>We weather the storm through tough times and benefit during good economic periods</li>
        </ul>
      </section>

      <section className="careers-apply">
        <h2>Apply Now</h2>
        <form action="https://formsubmit.co/it.magicmaxlogistics@gmail.com" method="POST"
         encType="multipart/form-data" className="careers-form">
                    <input type="hidden" name="_next" value="https://magicmaxlogistics.vercel.app/thank-you" />

           <input type="text" name="name" placeholder="Name" required />
          <input type="text" name="city" placeholder="City" required />
          <input type="email" name="email" placeholder="Email" required />
          {/* <input type="text" name="phonenumber" placeholder="Phone Number" required /> */}
          <div className="file-upload-wrapper">
  <label htmlFor="resume-upload" className="custom-upload">
    Upload Resume
  </label>
  <span className="file-name">{fileName}</span>
</div>
<input
  id="resume-upload"
  type="file"
  name="resume"
  accept="application/pdf,image/png,image/jpeg"
  required
  style={{ display: "none" }}
  onChange={handleFileChange}
/>
    <button type="submit">Apply Now</button>
</form>

      </section>

      <Footer />
    </div>
  );
};

export default Careers;
